module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av263-21fa97090923dde09ef849a2d9047b05.jpg";